<template>
  <div class="org-tree-content">
    <el-tabs v-model="activeName">
      <el-tab-pane style="height: 100%" label="总指挥部" name="first">
        <organization orgType="commander" v-if="activeName === 'first'"></organization>
      </el-tab-pane>
      <el-tab-pane style="height: 100%" label="项目指挥部" name="second">
        <organization orgType="headquarters" v-if="activeName === 'second'"></organization>
      </el-tab-pane>
      <el-tab-pane style="height: 100%" label="参建单位" name="third">
        <organization orgType="participateUnit" v-if="activeName === 'third'"></organization>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import organization from '../../components/orgTree/organization'
import postDuty from '../../components/orgTree/postDuty'
import qualityEnsure from '../../components/orgTree/qualityEnsure'
export default {
  name: "orgTree",
  components:{
    organization,
    postDuty,
    qualityEnsure
  },
  data() {
    return {
      activeName: 'first',
    }
  }
}
</script>

<style scoped>
.org-tree-content {
  width: 100%;
  height: 100%;
  padding: 10px;
  box-sizing: border-box;
}
.el-tabs {
  height: 100%;
}
/deep/ .el-tabs__content {
  height: calc(100% - 55px);
}
</style>



// WEBPACK FOOTER //
// src/views/orgTree/orgTree.vue